import React from 'react';
import { useOverlayContext } from 'seagull';
import { MapContactsModal } from "./MapContactsModal";
export const useOpenMapContactsModal = (clientContactId, reload) => {
  const overlayContext = useOverlayContext();
  return async function openMapContactsModal() {
    await overlayContext.showModal({
      closeOnClickOutside: false,
      closeOnEscapeKey: false,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/React.createElement(MapContactsModal, {
          dismissModal: dismissModal,
          contactIds: [clientContactId],
          onChange: () => reload()
        });
      }
    });
  };
};